import React, { ReactElement, forwardRef } from "react";
import { ToolbarCheckboxProps } from "./toolbar-checkbox.types";

export interface CheckboxWithForwardRef
  extends React.ForwardRefExoticComponent<
    ToolbarCheckboxProps & React.RefAttributes<HTMLInputElement>
  > {}

export const ToolbarCheckbox = forwardRef<
  HTMLInputElement,
  ToolbarCheckboxProps
>(
  (
    {
      checked,
      defaultChecked,
      disabled,
      label,
      name,
      onChange,
      value,
      ...rest
    },
    ref
  ): ReactElement => {
    return (
      <label>
        <input
          type="checkbox"
          checked={checked}
          defaultChecked={defaultChecked}
          value={value}
          disabled={disabled}
          name={name}
          onChange={(e): void => {
            onChange?.(e, e.target.value);
          }}
          ref={ref}
          {...rest}
        />
        <span className="spark-toolbar__list--checkboxes--helper"></span>
        <span className="spark-toolbar__list--checkboxes--content">
          {label}
        </span>
      </label>
    );
  }
) as CheckboxWithForwardRef;

ToolbarCheckbox.displayName = "ToolbarCheckbox";
